import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './Loader.scss';

export default class Loader extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
    mask: PropTypes.bool,
    solid: PropTypes.bool,
    fixed: PropTypes.bool,
    inline: PropTypes.bool
  };

  static defaultProps = {
    style: {},
    mask: true,
    solid: false,
    fixed: false,
    inline: false
  };

  render() {
    const { style, className, mask, solid, fixed, inline, children } =
      this.props;
    const classes = classNames('hotmart-loader', className, {
      'hotmart-loader--mask': mask,
      'hotmart-loader--fixed': fixed,
      'hotmart-loader--solid': solid,
      'hotmart-loade--inline': inline
    });

    return (
      <div className={classes} style={style} data-test="loader">
        <div className="hotmart-loader__circles">
          <div className="hotmart-loader__logo" />
        </div>
        {children}
      </div>
    );
  }
}
